/**
 * Strict mm/dd/yyyy date formatter.
 *
 * Accepts:
 *   - "yyyy-mm-dd" or "yyyy-mm-ddTHH:MM:SS..." strings (the form coming from
 *     HTML <input type="date"> and most ISO sources)
 *   - "mm/dd/yyyy" strings (returned as-is after re-padding)
 *   - Date objects
 *
 * Returns:
 *   - "mm/dd/yyyy" with zero-padded month and day
 *   - "" for null, undefined, empty, or unparseable values
 */
export function formatDate(value) {
  if (value === null || value === undefined || value === '') return '';

  // Date object
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return '';
    return toMDY(value.getFullYear(), value.getMonth() + 1, value.getDate());
  }

  if (typeof value !== 'string') return '';

  const trimmed = value.trim();
  if (!trimmed) return '';

  // yyyy-mm-dd (optionally followed by Tdd:dd...)
  const isoMatch = trimmed.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[T ]|$)/);
  if (isoMatch) {
    const [, y, m, d] = isoMatch;
    return toMDY(y, m, d);
  }

  // mm/dd/yyyy already
  const mdyMatch = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (mdyMatch) {
    const [, m, d, y] = mdyMatch;
    return toMDY(y, m, d);
  }

  return '';
}

function toMDY(year, month, day) {
  const m = String(month).padStart(2, '0');
  const d = String(day).padStart(2, '0');
  return `${m}/${d}/${year}`;
}

export default formatDate;